/* Fit complete phrases on a single line without changing their wording. */
(()=>{
 const fit=()=>document.querySelectorAll('.template-index .product-grid .affirmation-words,.template-index .hero-title').forEach(el=>{
  el.style.fontSize='';
  const width=el.matches('.hero-title')?el.parentElement.clientWidth:el.clientWidth;
  if(!width)return;
  let size=parseFloat(getComputedStyle(el).fontSize);
  if(el.scrollWidth>width){size*=width/el.scrollWidth;el.style.fontSize=(Math.floor(size*10)/10)+'px';}
 });
 const align=()=>{
  document.querySelectorAll('.template-index .product-grid').forEach(grid=>{
   if(grid.closest('.hope-collection'))return;
   const cards=[...grid.children].map(child=>child.matches('.product-card,.jar-preview')?child:child.querySelector('.product-card')).filter(Boolean);
   const groups=new Map();
   const parts=card=>[card.querySelector('.product-card__top h3')||card.querySelector('.product-card__copy>h3')||card.querySelector(':scope>h3'),card.querySelector('.product-card__meta'),card.matches('.jar-preview')?card.querySelector(':scope>p'):null];
   cards.forEach(card=>parts(card).forEach(el=>{if(el)el.style.minHeight=''}));
   cards.forEach(card=>{const top=Math.round(card.getBoundingClientRect().top);const key=[...groups.keys()].find(k=>Math.abs(k-top)<3)??top;groups.set(key,[...(groups.get(key)||[]),card])});
   groups.forEach(row=>{if(row.length<2)return;for(let i=0;i<3;i++){const els=row.map(card=>parts(card)[i]).filter(Boolean);const height=Math.max(0,...els.map(el=>el.getBoundingClientRect().height));els.forEach(el=>el.style.minHeight=height+'px')}});
  });
 };
 let frame;const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{fit();align()})};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule);else schedule();
 window.addEventListener('resize',schedule);window.addEventListener('load',schedule);
 if(document.fonts)document.fonts.ready.then(schedule);
 document.addEventListener('shopify:section:load',schedule);
})();
